const tintColorLight = '#027713';
const tintColorDark = '#fff';

export default {
  light: {
    text: '#000',
    background: '#fff',
    tint: tintColorLight,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorLight,
    primary: tintColorLight,
    primaryTint: '#fff',
    diabled: '#dddddd',
    cancel: '#4ea05a'
  },
  dark: {
    text: '#fff',
    background: '#000',
    tint: tintColorDark,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorDark,
    primary: tintColorDark,
    primaryTint: '#fff',
    diabled: '#dddddd',
    cancel: '#4ea05a'
  },
};
